type Props = {
  className?: string
}

const BackofficeIcon = ({ className = 'h-4 w-4' }: Props) => (
  <svg aria-hidden viewBox="0 0 24 24" className={`${className} fill-none stroke-current stroke-[1.9]`}>
    <circle cx="12" cy="8" r="3.2" />
    <path d="M5.5 19.5c.9-3.2 3.6-5 6.5-5s5.6 1.8 6.5 5" />
  </svg>
)

export default BackofficeIcon
